import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { LEGAL_TEXT } from '../../utils/utils';

export const LegalMessaging = () => {
  return (
    <div className="sui-bg-primary sui-p-4" data-component="LegalMessaging">
      <Typography weight="bold">
        <span className=" sui-text-sm sm:sui-text-lg">{LEGAL_TEXT}</span>
      </Typography>
    </div>
  );
};
